module.exports = __webpack_public_path__ + "frontend/images/about/map@2.png?3098982faa4463bd238b1b6a5abfb5a6";